import React, {useState,useEffect, useContext } from "react"
import styled from "styled-components"
import {SectionContext} from "../context/sectionContext"
import {ErrorContext} from "../context/errorContext"
import { ConditionContext } from "../context/conditionContext"
import { fetchPincodeDetails, getChoiceMasters } from "../../services/apiservice"
import * as lookup from "../../../static/lookup.json"
import * as sectionKeysToCheckNegativePincode from "../../../static/sectionKeysToCheckForNegativePincode.json"
import {JourneyContext} from "../context/journeyContext";
import { getValueFromJourney,getValueFromLookup } from "../services/helperFunctions"
import { lineCapital } from "../../shared/functions"
import { isIE } from 'react-device-detect';

const NumberContainer = styled.div`
  display: block;
  margin: 13px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;

    & > input {
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
      background: var(--lumiq-bg);
    }
  }
`

export default function ComponentTextNumber(props) {
  
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [showLocalError, setShowLocalError] = useState(false)
  const [journeyState, setJourneyState] = useContext(JourneyContext);
  const validate = (target) =>  {
    if(props.data.required){ // required field validation
      // console.log("required")
      if(sectionState.sectionData && ((sectionState.sectionData[props.data.formControlKey] === "") || (!sectionState.sectionData[props.data.formControlKey]) )){
        setErrorState( prev => {
          return ({
            ...prev,
            // [props.data.formControlKey]: props.data.requiredError ? props.data.requiredError : `Please Enter ${props.data.label}`
            [props.data.formControlKey]: props.data.requiredError
            ? lineCapital(getValueFromLookup(
              "required_error",
              props.data.requiredError
            )) : `Error Code Not Found in Strapi`,
          })
        })
        return
      }else{
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
      if(target.value){
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }
    if(target.value){
      if(props.data.min_len){ // min_len validation
        if(target.value.length < props.data.min_len){
          setErrorState(prev => {
            return({
              ...prev,
                  [props.data.formControlKey]: `Minimum length should be ${props.data.min_len}`
            })
          })
          setShowLocalError(true)
          return
        }else{
          setErrorState(prev => {
            return({
              ...prev,
              [props.data.formControlKey]: ""
            })
          })
        }
      }
      if(props.data.max_len){ //max length validation
        if (target.value.length > props.data.max_len) {
          setErrorState(prev => {
            return({
              ...prev,
              [props.data.formControlKey]: `Maximum length required is ${props.data.max_len}`
              // [props.data.formControlKey]:  lineCapital(getValueFromJourney(
              //   journeyState.lookup.max_error,
              //   props.data.max_len_error
              // ))
            })
          })
          setShowLocalError(true)
          return
        }
        else{
          setErrorState(prev => {
            return({
              ...prev,
              [props.data.formControlKey]: ""
            })
          })
        }
      }
      if (props.data.min_value) {
        let val = Number(target.value)
        if (val < props.data.min_value) {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data
                .formControlKey]: `Value can't be less than ${props.data.min_value}`,
            }
          })
        }
      }
      if (props.data.max_value) {
        let val = Number(target.value)
        if (val > props.data.max_value) {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data
                .formControlKey]: `Value can't be more than ${props.data.max_value}`,
            }
          })
        }
      }
      if (props.data.regex) {
        let regex = (props.data.regex.toString())
        let rg = regex.substring(1, regex.lastIndexOf('/'))
        let flags = regex.substring(regex.lastIndexOf('/') + 1)
        let regex_exp = new RegExp(rg, flags)
        if (regex_exp.test(target.value)) {
          setErrorState(prev => {
            return({
              ...prev,
              [props.data.formControlKey]: ""
            })
          })
        }
        else if(props.data.formControlKey === "eiaNumber")
        {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: props.data.requiredError
                ? lineCapital(getValueFromLookup(
                  "required_error",
                  props.data.regexError
                )) : `Error Code Not Found in Strapi`,
            })
          })
          setShowLocalError(true)
          return
        }
        else {
          setErrorState(prev => {
            return({
              ...prev,
              [props.data.formControlKey]: `Please enter valid  ${lineCapital(getValueFromLookup(
                "label",
                props.data.label
              )) || props.data.label}`
            })
          })
          setShowLocalError(true)
          return
        }
      }
    }else{
      console.log("===>12345")
      setErrorState(prev => {
        return({
          ...prev,
          [props.data.formControlKey]: ""
        })
      })
    }
    // console.log(errorState)
    return 
  }


  const checkForPincodes = (target) => {  
    if (props.data.formControlKey.toLowerCase().includes("pincode") && (target.value && target.value.length === 6)) {
      //general function to set any form control key in section state
      const asyncStateSetter = (pageId, sectionId, componentGroupId, stateFormControlKey, cityComponentId, cityFormControlKey) => {
        let payload = {
          "pincode": target.value
        }
        fetchPincodeDetails(payload)//133001 ,201304
        .then(res => {
          let temp = journeyState.journeySteps
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
          let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
          let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroupId)
          let tempComponentGroupCityIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === cityComponentId)
          let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === stateFormControlKey)
          // let tempComponentCityIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupCityIndexToChange].components.findIndex(element => element.formControlKey === cityFormControlKey)
          console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")
          if(res && res.pincodeDetails.state){
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]['freeze'] = true;
          }
          else{
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]['freeze'] = false;
          }
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [stateFormControlKey]: res?.pincodeDetails?.state,
                [cityFormControlKey]: res?.pincodeDetails?.city?.toUpperCase()
              }
            })
          })
          console.log(conditionState, "pincode conditionState")
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${cityFormControlKey}`]: res?.pincodeDetails?.city?.toUpperCase(),
            }
          })
          if(!res?.pincodeDetails?.city){
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [cityFormControlKey]: "OTHERS"
                }
              })
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${cityFormControlKey}`]: "OTHERS",
              }
            })
          }
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        })
        .catch((err) => {
          // This case executes If pincode not valid
          console.log("Please enter valid pincode", err)
          setErrorState(prev => {
            return({
              ...prev,
              [props.data.formControlKey]: `Please enter valid pincode`
            })
          })
          if(props.sectionId === "CPResidentAndOccupationDetailSection" || props.sectionId === "youngTermCPResidentAndOccupationDetailSection" || props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" || props.sectionId === "SectionULIPOccupationDetails" || props.sectionId === "SectionULIPCommunicationAddress" && props.data.formControlKey == "pincode"){
            emptyFormControKeyInState("state")
            emptyFormControKeyInState("city", "cityName")
            functionToEmptyStateAndUnfreeze()
          }else if(props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "pincode"){
            emptyFormControKeyInState("state")
            emptyFormControKeyInState("city", "cityName")
          }else if(props.sectionId === "residenceDetailsSection" || props.sectionId === "SectionULIPCommunicationAddress" && props.data.formControlKey == "PRPincode"){
            emptyFormControKeyInState("PRState")
            emptyFormControKeyInState("PRCity", "PRcityName")
          }
          else if(props.sectionId === "sectionISelect360ProfessionalDetail" && props.data.formControlKey == "pincode"){
            emptyFormControKeyInState("state")
            emptyFormControKeyInState("city", "cityName")
          }
          setShowLocalError(true)
          return
        })
      }
      const emptyFormControKeyInState = (formControlKeyToEmpty, formControlKeyCityName) => {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [formControlKeyToEmpty]: ""
            }
          })
        })
        if(formControlKeyToEmpty === "city" || formControlKeyToEmpty === "PRCity"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [formControlKeyCityName]: ""
              }
            })
          })
          // setConditionState(prev => {
          //   return {
          //     ...prev,
          //     [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
          //   }
          // })
        }
      }

      const unfreezeField = (pageId, sectionId, componentGroupId, stateFormControlKey) => {
        let temp = journeyState.journeySteps
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroupId)
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === stateFormControlKey)
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "dfefd")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]['freeze'] = false;
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }

      const functionToEmptyStateAndUnfreeze = () => {
        let fillProposalPageId
        let fillcalculatePageId
        if(props.journeyIdFromStrapi === "iSelectJourney"){
            fillcalculatePageId = "calculatePremiumPage"
            fillProposalPageId = "fillProposalForm"
        }else if(props.journeyIdFromStrapi === "ISelect360Journey"){
            fillcalculatePageId = "PageISelect360CalculatePremium"
            fillProposalPageId = "pageISelect360FillProposalForm"
        } else if(props.journeyIdFromStrapi === "youngTermPlanJourney"){
          fillcalculatePageId = "PageYoungTermCalculatePremium"
          fillProposalPageId = "pageISelect360FillProposalForm"
        }
        if(props.sectionId === "CPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode"){
          emptyFormControKeyInState("state")
          unfreezeField(fillcalculatePageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state")
        }else if(props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode"){
          emptyFormControKeyInState("state")
          unfreezeField(fillcalculatePageId, "iSelect360CPResidentAndOccupationDetailSection","iSelect360CPResidentAndOccupationDetail","state")
        }
        else if(props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "pincode"){
          emptyFormControKeyInState("state")
          unfreezeField(fillProposalPageId, "residenceDetailsSection", "state","state")
        }
        else if(props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "PRPincode"){
          emptyFormControKeyInState("PRState")
          unfreezeField(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState")
        }
        else if(props.sectionId === "sectionISelect360ProfessionalDetail" && props.data.formControlKey == "PRPincode"){
          emptyFormControKeyInState("state")
          unfreezeField(fillProposalPageId, "sectionISelect360ProfessionalDetail", "iSelectSmart360PDState", "state")
        }
        else if(props.sectionId === "youngTermCPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode"){
          emptyFormControKeyInState("state")
          unfreezeField(fillcalculatePageId, "youngTermCPResidentAndOccupationDetailSection","youngtermPlanCPResidentAndOccupationDetail","state")
        }

        /* The below commented code will help in making above conditions for POS and ULIP Journey*/

        // if(props.sectionId === "CPResidentAndOccupationDetailSection" || props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" || props.sectionId === "SectionULIPOccupationDetails" || props.sectionId === "SectionULIPCommunicationAddress" && props.data.formControlKey == "pincode"){
        //   emptyFormControKeyInState("state")
        //   asyncStateSetter(fillcalculatePageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state")
        // }else if(props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "pincode"){
        //   emptyFormControKeyInState("state")
        // }else if(props.sectionId === "residenceDetailsSection" || props.sectionId === "SectionULIPCommunicationAddress" && props.data.formControlKey == "PRPincode"){
        //   emptyFormControKeyInState("PRState")
        // }
        // setShowLocalError(true)
      }

      const checkNegativePincode = () => {
        const negativePincodes = lookup["negativePincodes"]
        let index = negativePincodes.findIndex(element => element === target.value)
        if (index !== -1) {
          let conditionStateValueEducationQualification
          let conditionStateValueAnnualIncome
          if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
            conditionStateValueEducationQualification = conditionState["calculatePremiumPage.CPPersonalDetailsSection.educationalQualification"]
            conditionStateValueAnnualIncome = conditionState["calculatePremiumPage.CPPersonalDetailsSection.AnnualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
            conditionStateValueEducationQualification = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.educationalQualification"]
            conditionStateValueAnnualIncome = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.AnnualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "youngTermPlanJourney") {
            conditionStateValueEducationQualification = conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.educationalQualification"]
            conditionStateValueAnnualIncome = conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.AnnualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney") {
            conditionStateValueEducationQualification = conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.educationalQualification"]
            conditionStateValueAnnualIncome = conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.AnnualIncome"]
          }

          if (!["1", "2"].includes(conditionStateValueEducationQualification)) {
            setErrorState(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: `This Pincode is not serviceable`
              })
            })
            functionToEmptyStateAndUnfreeze()
            return true
          } else {
            if (conditionStateValueAnnualIncome < 500000) {
              setErrorState(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: `This Pincode is not serviceable`
                })
              })
              functionToEmptyStateAndUnfreeze()
              return true

            }else {
              return false
            }
          }
        }else {
          return false
        }
      }

      const pincodeApiCallsAndStateFillingMultipeJourney = () => {
        let fillProposalPageId
        let fillcalculatePageId
        if(props.journeyIdFromStrapi === "iSelectJourney"){
            fillcalculatePageId = "calculatePremiumPage"
            fillProposalPageId = "fillProposalForm"
        }else if(props.journeyIdFromStrapi === "ISelect360Journey"){
            fillcalculatePageId = "PageISelect360CalculatePremium"
            fillProposalPageId = "pageISelect360FillProposalForm"
        }else if(props.journeyIdFromStrapi === "youngTermPlanJourney"){
          fillcalculatePageId = "PageYoungTermCalculatePremium"
          fillProposalPageId = "pageISelect360FillProposalForm"
        }
        // For dynamic pageID
        if(props.sectionId === "CPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode"){
            asyncStateSetter(fillcalculatePageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state")
        }
        else if(props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode"){
          asyncStateSetter(fillcalculatePageId, "iSelect360CPResidentAndOccupationDetailSection","iSelect360CPResidentAndOccupationDetail","state", "iSelect360CPResidentAndOccupationDetail", "city")
        }
        else if(props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "pincode"){
          asyncStateSetter(fillProposalPageId, "residenceDetailsSection", "state","state", "cityName", "cityName")
        }
        else if(props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "PRPincode"){
          asyncStateSetter(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "permanentResidentialDetails", "PRCity")
        }else if (props.sectionId === "AppointeeDetailSection" && props.data.formControlKey == "appointeePincode"){
          asyncStateSetter(fillProposalPageId,"AppointeeDetailSection","AppointeeCommuncationDetailsTermPlan","appointeeState","cityAppointee","cityAppointee")
        }
        else if(props.sectionId === "sectionISelect360ProfessionalDetail" && props.data.formControlKey == "pincode"){
          asyncStateSetter(fillProposalPageId, "sectionISelect360ProfessionalDetail", "iSelectSmart360PDState", "state", "iSelectSmart360PDcity", "city")
        }
        // For GSP
        else if(props.sectionId === "SectionPOSOccupationDetails" && props.data.formControlKey == "pincode"){
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSOccupationDetails", "officeState-MD-4-Order-12","state")
        }
        else if(props.sectionId === "SectionPOSCommunicationAddress" && props.data.formControlKey == "pincode"){
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSCommunicationAddress", "state","state")
        }else if(props.sectionId === "SectionPOSCommunicationAddress" && props.data.formControlKey == "PRPincode"){
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSCommunicationAddress", "permanentResidentialDetailsWithLandMark-MD-12-Order", "PRState")
        }
        else if(props.sectionId === "SectionPOSProposerDetails" && props.data.formControlKey == "employerPincode"){
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSProposerDetails", "employerLocation", "employerState")
        }
        else if(props.sectionId === "SectionPOSProposerDetails" && props.data.formControlKey == "pincode"){
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSProposerDetails", "communicationAddress", "state")
        }
        else if(props.sectionId === "SectionPOSProposerDetails" && props.data.formControlKey == "pincodePermanent"){
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSProposerDetails", "permanentAddress", "statePermanent")
        }
        //young term
        else if(props.sectionId === "youngTermCPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode"){
          asyncStateSetter(fillcalculatePageId, "youngTermCPResidentAndOccupationDetailSection","youngtermPlanCPResidentAndOccupationDetail","state", "youngtermPlanCPResidentAndOccupationDetail", "city")
        }
      }

      //checking for incorrect pincode
      if(target.value == "000000") {
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: `This Pincode is incorrect`
          })
        })
        functionToEmptyStateAndUnfreeze()
        return 
      }

      let sectionNegativePincodeKeys = sectionKeysToCheckNegativePincode[props.sectionId]
      if(sectionNegativePincodeKeys && sectionNegativePincodeKeys.length && sectionNegativePincodeKeys.includes(props.data.formControlKey)){
        let isPincodeNegative = checkNegativePincode()
        pincodeApiCallsAndStateFillingMultipeJourney()
        
      }else{
        pincodeApiCallsAndStateFillingMultipeJourney()
      }
    }
  }

  const checkAlternateContact = (target) => {
    if(props.data.formControlKey.toLowerCase().includes("alternatemobnumber") && props.sectionId === "personalDetailsSection"){
      if(target.value === sectionState.sectionData["contactNumber"] && target.value?.length === 10){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Mobile number and Alternate Mobile number should not be same"
          })
        })
      }
    }
  }

  const checkPercentage = (target) => {
    if(props.data.formControlKey === "OccupationalOilNaturalQPhysicalDuties" && props.sectionId === "OccupationalQuestionnaireSectionOil"){
      // console.log("====>inside1", sectionState.sectionData["OccupationalOilNaturalQPhysicalDuties"] )
      if(sectionState.sectionData["OccupationalOilNaturalQPhysicalDuties"] > 100 || sectionState.sectionData["OccupationalOilNaturalQPhysicalDuties"] < 0){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Percentage Should Be Between 0 to 100"
          })
        })
        setShowLocalError(true)
      }else{
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }else if(props.data.formControlKey === "MerchantMarineQNaturePhysicalNatureDuties" && props.sectionId === "OccupationalQuestionnaireSectionMarine"){
      console.log("====>inside1", sectionState.sectionData["MerchantMarineQNaturePhysicalNatureDuties"] )
      if(sectionState.sectionData["MerchantMarineQNaturePhysicalNatureDuties"] > 100 || sectionState.sectionData["MerchantMarineQNaturePhysicalNatureDuties"] < 0){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Percentage Should Be Between 0 to 100"
          })
        })
        setShowLocalError(true)
      }else{
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }else if(props.data.formControlKey === "MiningQuestionnairePhysicalNatureDuties" && props.sectionId === "OccupationalQuestionnaireSectionMining"){
      console.log("====>inside1", sectionState.sectionData["MiningQuestionnairePhysicalNatureDuties"] )
      if(sectionState.sectionData["MiningQuestionnairePhysicalNatureDuties"] > 100 || sectionState.sectionData["MiningQuestionnairePhysicalNatureDuties"] < 0){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Percentage Should Be Between 0 to 100"
          })
        })
        setShowLocalError(true)
      }else{
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }else if(props.data.formControlKey === "OccupationalOilNaturalQPhysicalDuties" && props.sectionId === "SpouseOccupationalQuestionnaireSectionOil"){
      console.log("====>inside1", sectionState.sectionData["OccupationalOilNaturalQPhysicalDuties"] )
      if(sectionState.sectionData["OccupationalOilNaturalQPhysicalDuties"] > 100 || sectionState.sectionData["OccupationalOilNaturalQPhysicalDuties"] < 0){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Percentage Should Be Between 0 to 100"
          })
        })
        setShowLocalError(true)
      }else{
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }else if(props.data.formControlKey === "MerchantMarineQNaturePhysicalNatureDuties" && props.sectionId === "SpouseOccupationalQuestionnaireSectionMarine"){
      console.log("====>inside1", sectionState.sectionData["MerchantMarineQNaturePhysicalNatureDuties"] )
      if(sectionState.sectionData["MerchantMarineQNaturePhysicalNatureDuties"] > 100 || sectionState.sectionData["MerchantMarineQNaturePhysicalNatureDuties"] < 0){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Percentage Should Be Between 0 to 100"
          })
        })
        setShowLocalError(true)
      }else{
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }else if(props.data.formControlKey === "MiningQuestionnairePhysicalNatureDuties" && props.sectionId === "SpouseOccupationalQuestionnaireSectionMining"){
      console.log("====>inside1", sectionState.sectionData["MiningQuestionnairePhysicalNatureDuties"] )
      if(sectionState.sectionData["MiningQuestionnairePhysicalNatureDuties"] > 100 || sectionState.sectionData["MiningQuestionnairePhysicalNatureDuties"] < 0){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Percentage Should Be Between 0 to 100"
          })
        })
        setShowLocalError(true)
      }else{
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }
  }

  useEffect(() => {
    validate({value: sectionState.sectionData?.[props.data.formControlKey]?? ""})
  },[sectionState.sectionData?.[props.data.formControlKey]])

  useEffect(() => {
    if(sectionState.sectionData?.[props.data.formControlKey]){
      dataMask({
        value: sectionState.sectionData?.[props.data.formControlKey] ?? "",
      },"mask")
    }
  },[sectionState?.sectionFirstPass, sectionState?.sectionId])

  const handleChange = ({target}) => {
    if(/^[0-9]*$/.test(target.value)){
      if(sectionState.sectionId === props.sectionId){
        setSectionState((prev) => {
          return (
            {
              ...prev,
              sectionData:{
                ...prev.sectionData,
                [props.data.formControlKey]: target.value,
                [props.data.maskedKey]: target.value
              }
            }
          )
        })
      }else{
        setSectionState((prev) => {
          return (
            {
              ...prev,
              sectionId: props.sectionId,
              sectionData:{
                ...prev.sectionData,
                [props.data.formControlKey]: target.value,
                [props.data.maskedKey]: target.value
              }
            }
          )
        })
      }
      validate(target)
    }
    //console.log(sectionState, "section state")
  }

  const dataMask = (target, name) => {
      let maskValue
      if(name === "mask"){
      if(props.data.maskType === "number"){
          let mask = target.value.slice(0,5)
          maskValue = `${mask}XXXXX`
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.maskedKey]: maskValue
              }
            })
          })
        } else if(props.data.maskType === "string"){
          maskValue = target.value.slice(0, 5) + "*****"
          setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.maskedKey]: maskValue
            }
          })
        })
        }
      } else {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.maskedKey]: sectionState?.sectionData[props.data.formControlKey],
                }
              })
            })
          }
        }

  return (
    <>
    <style>{
      `input[type=number]::-webkit-inner-spin-button, 
      input[type=number]::-webkit-outer-spin-button { 
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          margin: 0; 
      }`
      }
    </style>
      <NumberContainer channel={props.channel}  className={`form-group input-container ${props.data.disabled?'disable-input':''}`} >
      <label htmlFor={props.data.label} className="input-label" >{(getValueFromLookup(
          "label",
          props.data.label
        )) || props.data.label}</label>
        <input
          className={"form-control " + (isIE ? 'IELineHeight' : '')}
          // className={`form-control`}
          type={props.data.type}
          placeholder={(getValueFromLookup(
            "placeholder",
            props.data.placeholder
          )) || props.data.placeholder}
          required={props.data.required}
          disabled={props.data.disabled}
          onChange={handleChange}
          onClick={(e) => {
            props.data.isMasked && dataMask(e.target,"nonMask")
          }}
          autoComplete="new-password"
          value={props.data.isMasked ? sectionState.sectionData?.[props.data.maskedKey]
            : (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) ? sectionState.sectionData[props.data.formControlKey] : ""}
          onBlur={(e) => {checkForPincodes(e.target)
            checkAlternateContact(e.target)
            checkPercentage(e.target)
            props.saveApplicationAndCallBi && 
            props.saveApplicationAndCallBi(props.data.formControlKey, e.target.value)
            props.data.isMasked && dataMask(e.target,"mask")}}
            
          maxLength={props.data.max_len}
        ></input>
        {
          props?.data?.formControlKey === "eiaNumber" ? 
          (
            <span className="input-error2">{(props.showError || showLocalError) && errorState[props.data.formControlKey]}
            </span>)
          : (sectionKeysToCheckNegativePincode[props.sectionId] && sectionKeysToCheckNegativePincode[props.sectionId].length && sectionKeysToCheckNegativePincode[props.sectionId].includes(props.data.formControlKey) && errorState[props.data.formControlKey] === "This Pincode is not serviceable")
          ? <span></span>
          :
          (
            <span className="input-error">{(props.showError || showLocalError) && errorState[props.data.formControlKey]}
            </span>
          )
        }
      </NumberContainer>
      
    </>
  )
}
